/* ==========================================================================
   MAISON REVØRA — Basis-Skript fürs Shopify-Theme (16.10.2026)
   Aus dem Vorschau-Prototyp übernommen: Helfer, Farbregel, Karten, Merkliste, Menüs.
   Neu: Daten kommen aus <script type="application/json" data-rv-products> (snippets/rvm-pjson),
   echte URLs, Warenkorb über die Shopify-Ajax-API (/cart.js, /cart/add.js, /cart/change.js),
   Suche über /search/suggest.json, Seitenstart über <div id="rv-main" data-rv-page="…">.
   Seiten registrieren sich weiter mit RV.page(name, {title, header, render(el, ctx)}).
   ========================================================================== */
(function () {
  "use strict";
  const CFG = window.RVM_CFG || { root: "/", locale: "de", banner: {} };
  const RVM = { en: CFG.locale === "en", root: CFG.root || "/" };
  /* In der Theme-Vorschau gehen eigene JSON-Abrufe an dieselbe (unveröffentlichte) Theme-Version */
  const PV = window.Shopify && Shopify.theme && Shopify.theme.role !== "main" ? "preview_theme_id=" + Shopify.theme.id : "";
  RVM.pv = (u) => (PV ? u + (u.includes("?") ? "&" : "?") + PV : u);
  const RV = (window.RV = window.RV || {});
  RV.cfg = CFG;
  RV.pv = RVM.pv;
  RV.pages = {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  RV.$ = $; RV.$$ = $$;

  /* ---------- Basis-Helfer ---------- */
  /* ---------- Basis-Helfer ---------- */
  const ESC = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
  RV.esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ESC[c]);
  RV.price = (c) => (RVM.en ? "€" + (c / 100).toLocaleString("en-IE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (c / 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €");
  RV.img = (u, w) => (u ? u + (u.includes("?") ? "&" : "?") + "width=" + w : "");
  RV.srcset = (u, ws = [360, 540, 720, 900, 1200, 1600]) => ws.map((w) => RV.img(u, w) + " " + w + "w").join(", ");
  RV.imgTag = (u, { w = 900, sizes = "50vw", alt = "", cls = "", eager = false, ws } = {}) =>
    `<img class="${cls}" src="${RV.img(u, w)}" srcset="${RV.srcset(u, ws)}" sizes="${sizes}" alt="${RV.esc(alt)}" loading="${eager ? "eager" : "lazy"}" decoding="async"${eager ? ' fetchpriority="high"' : ""}>`;
  RV.debounce = (fn, ms = 160) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- Fakten (geprüft, gleiche Quelle wie die Vorschau) ---------- */
  const FAKTEN_DE = {
    versand: "Kostenloser Standardversand nach Deutschland und in die Schweiz – ohne Mindestbestellwert",
    versand_kurz: "Kostenloser Versand · DE · CH",
    lieferzeit: "Deutschland 2–5, Schweiz 3–10 Werktage (Mo–Fr) ab Bestellung – Druck und Versand inklusive",
    express: "",
    druck: "Nach deiner Bestellung in Deutschland bedruckt – kein Lager, keine Restposten",
    stoff: "100 % gekämmte Baumwolle, Single Jersey, 220 g/m² – oversized, unisex",
    widerruf: "14 Tage Widerrufsrecht ab Erhalt – Anprobieren ausdrücklich erlaubt. Rücksendekosten trägt der Kunde.",
    code: "−5 % auf deine erste Bestellung mit WELCOME5",
    staffel: "Ab 2 Teilen automatisch −5 % · ab 2 Winterteilen −10 %",
    zahlung: ["Visa", "Mastercard", "American Express", "Maestro", "PayPal", "Apple Pay", "Google Pay", "Shop Pay", "Klarna", "EPS"],
    dhl: "Versand mit DHL, Tracking-Link per E-Mail",
    kontakt: "info@revora-store.eu",
    adresse: "REVØRA – Pedram Panahi Olfat, Trockener Kamp 8, 31139 Hildesheim, Deutschland",
    gegruendet: "Gegründet in Hildesheim",
  };
  const FAKTEN_EN = Object.assign({}, FAKTEN_DE, {
    versand: "Free standard shipping to Germany and Switzerland – no minimum order",
    versand_kurz: "Free shipping · DE · CH",
    lieferzeit: "Germany 2–5, Switzerland 3–10 business days (Mon–Fri) from order – printing and shipping included",
    express: "",
    druck: "Printed in Germany after you order – no stock, no leftovers",
    stoff: "100% combed cotton, single jersey, 220 g/m² – oversized, unisex",
    widerruf: "14-day right of withdrawal from receipt – trying on is explicitly allowed. Return shipping is paid by the customer.",
    code: "−5% on your first order with WELCOME5",
    staffel: "From 2 pieces automatically −5% · 2 winter pieces −10%",
    dhl: "Shipped with DHL, tracking link by email",
    gegruendet: "Founded in Hildesheim",
  });
  const D = (RV.D = {
    products: [], collections: [], pages: {},
    fakten: RVM.en ? FAKTEN_EN : FAKTEN_DE,
    banner: CFG.banner || {}, logo: CFG.logo || "", shop: location.origin,
  });

  /* ---------- Daten: kompaktes Liquid-JSON -> Prototyp-Format ---------- */
  const PBY = new Map(), CBY = new Map();
  const HEX = { Black: "#141414", "French Navy": "#1f2b47", White: "#ffffff", "Heather Grey": "#b8b8ba", "Natural Raw": "#efe7d6", "Off White": "#f4f2ec", "Union Beige": "#d6c5aa", "Desert Sand": "#d3bf9c", Beige: "#e3d7c2", Charcoal: "#3b3e42" };
  const abs = (u) => (!u ? "" : u.startsWith("//") ? "https:" + u : u);
  const kind = (alt) => {
    const a = (alt || "").toLowerCase();
    if (a.includes("getragen") && a.includes("vorder")) return "model_front";
    if (a.includes("getragen")) return "model";
    if (a.includes("nähe")) return "detail";
    if (a.includes("brust") || a.includes("vorderansicht")) return "front";
    if (a.includes("rückansicht")) return "back";
    return "other";
  };
  const cleanDesc = (h) => String(h || "").replace(/<br\s*\/?>\s*(<br\s*\/?>)*/g, "").replace(/\s(style|class|data-[\w-]+)="[^"]*"/g, "").replace(/<(\/?)(span|div|meta)[^>]*>/g, "").trim();
  function norm(x) {
    const o = x.o || [], ov = x.ov || [];
    const oi = o.findIndex((n) => /farb|colou?r/i.test(n));
    const si = o.findIndex((n) => /gr(ö|oe)(ß|ss)e|size/i.test(n));
    const colors = oi >= 0 ? ov[oi] || [] : [];
    const sizes = si >= 0 ? ov[si] || [] : [];
    const byLen = colors.slice().sort((a, b) => b.length - a.length);
    const groups = {};
    (x.im || []).forEach(([u, w, h, a]) => {
      const al = a || "";
      let c = byLen.find((c) => al.includes(" in " + c + ",") || al.endsWith(" in " + c) || al.includes(" in " + c + " "));
      if (!c) c = colors[0] || "—";
      (groups[c] = groups[c] || []).push({ u: abs(u), a: al, w, h, k: kind(al) });
    });
    /* Atila 19.10.2026: hinten kein Motiv (RØ-Basics, Clean-Teile, Bomber/Fleece nur mit Wortmarke) -> immer VORNE zuerst
       (Karte, Galerie, Farbfeld); Hover zeigt dann die Vorderansicht/das Detail statt des leeren Rückens. */
    const ohneR = /^RØ(\s|$)|\bclean\b/i.test(x.t || "") || (x.tg || []).includes("ohne-rueckenmotiv");
    const vorneZuerst = ohneR || /jogger|cap|mütze|beanie/i.test(x.ty || "") || /jogger|cap\b/i.test(x.t || "");
    const cl = (colors.length ? colors : Object.keys(groups)).map((n) => {
      const ims = groups[n] || [];
      if (!ims.length) return null;
      const ks = ims.map((i) => i.k);
      /* Atila 04.11.2026: erstes Bild immer der Packshot */ let card = ks.indexOf(vorneZuerst ? "front" : "back"); if (card < 0) card = ks.indexOf(vorneZuerst ? "back" : "front"); if (card < 0) card = ks.indexOf(vorneZuerst ? "model_front" : "model"); if (card < 0) card = ks.indexOf(vorneZuerst ? "model" : "model_front"); if (card < 0) card = 0;
      let hover = ks.indexOf(vorneZuerst ? "model_front" : "model"); if (hover < 0) hover = ks.indexOf(vorneZuerst ? "model" : "model_front"); if (hover < 0 || hover === card) hover = ks.findIndex((k, i) => i !== card); if (hover < 0) hover = card;
      return { n, x: HEX[n] || "#cccccc", im: ims, card, hover };
    }).filter(Boolean);
    const names = cl.map((c) => c.n);
    const v = (x.v || []).map(([id, o1, o2, pr, cmp, av]) => {
      const op = [o1, o2];
      const ci = oi >= 0 ? names.indexOf(op[oi]) : 0;
      const sz = si >= 0 ? sizes.indexOf(op[si]) : 0;
      return [id, ci, sz < 0 ? 0 : sz, pr, cmp || 0, av ? 1 : 0];
    }).filter((r) => r[1] >= 0);
    const price = v.length ? Math.min(...v.map((r) => r[3])) : x.p || 0;
    const cmp = Math.max(0, x.cp || 0, ...v.map((r) => r[4]));
    return { h: x.h, t: x.t, ty: x.ty || "", ohneR, tags: x.tg || [], p: price, cp: cmp > price ? cmp : 0, neu: (x.tg || []).includes("neu-okt26"), created: x.cr,
      c: cl, s: sizes, v, d: cleanDesc(x.d), col: x.col || [], slim: !x.v };
  }
  RV.addProducts = (list) => (list || []).forEach((x) => {
    if (!x || !x.h) return;
    const old = PBY.get(x.h);
    if (old && !old.slim && !x.v) return; /* volle Daten nie durch schlanke ersetzen */
    const p = norm(x);
    if (!p.c.length) return;
    if (old) Object.assign(old, p); else { PBY.set(p.h, p); D.products.push(p); }
  });
  RV.addCollections = (list) => (list || []).forEach((c) => { if (c && c.h) { CBY.set(c.h, c); if (!D.collections.includes(c)) D.collections.push(c); } });
  RV.prod = (h) => PBY.get(h);
  RV.coll = (h) => CBY.get(h);
  RV.collProducts = (h) => ((CBY.get(h) || {}).p || []).map((x) => PBY.get(x)).filter(Boolean);
  /* fehlende Produkte nachladen (Merkliste, Zuletzt angesehen) über /products/<h>.js */
  RV.fetchProduct = async (h) => {
    if (PBY.get(h) && !PBY.get(h).slim) return PBY.get(h);
    try {
      const r = await fetch(RVM.root + "products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } });
      if (!r.ok) { if (r.status === 404) { const l = RV.wish.list(), i = l.indexOf(h); if (i >= 0) { l.splice(i, 1); store.set("rv_wish", l); RV.wish.sync(); } } return null; }
      const j = await r.json();
      const names = (j.options || []).map((o) => (typeof o === "string" ? o : o.name));
      const vals = names.map((_, i) => { const s = []; (j.variants || []).forEach((v) => { const x = v["option" + (i + 1)]; if (x != null && !s.includes(x)) s.push(x); }); return s; });
      RV.addProducts([{ h: j.handle, t: j.title, ty: j.type, tg: j.tags || [], cr: (j.created_at || "").slice(0, 10), o: names, ov: vals,
        im: (j.media || []).filter((m) => m.media_type === "image").map((m) => [m.src, m.width, m.height, m.alt || ""]),
        v: (j.variants || []).map((v) => [v.id, v.option1 || "", v.option2 || "", v.price, v.compare_at_price || 0, v.available ? 1 : 0]),
        col: [], p: j.price, cp: j.compare_at_price_max || 0, d: j.description }]);
      return PBY.get(h);
    } catch (e) { return null; }
  };
  RV.fetchProducts = (hs) => Promise.all((hs || []).map(RV.fetchProduct)).then((l) => l.filter(Boolean));

  RV.colorIndex = (p, name) => Math.max(0, p.c.findIndex((c) => c.n === name));
  RV.variant = (p, ci, si) => p.v.find((v) => v[1] === ci && v[2] === si);
  RV.isAvail = (p, ci, si) => { const v = RV.variant(p, ci, si); return !!(v && v[5]); };
  const TYPE_EN = { "Unisex-Shirts": "Oversized shirt", "Open-Hem-Jogger": "Joggers", Fleecejacken: "Fleece jacket", Jacken: "Jacket", Caps: "Cap", Hoodies: "Hoodie", Sweatshirts: "Sweatshirt", "Zip-Hoodies": "Zip hoodie", Longsleeves: "Longsleeve", Jogger: "Joggers", Softshelljacken: "Softshell jacket" };
  RV.typeLabel = (p) => (RVM.en && TYPE_EN[p.ty]) || ({ "Unisex-Shirts": "Oversized Shirt", "Open-Hem-Jogger": "Jogger", Fleecejacken: "Fleecejacke", Jacken: "Jacke", Caps: "Cap", Hoodies: "Hoodie", Sweatshirts: "Sweatshirt", "Zip-Hoodies": "Zip-Hoodie", Longsleeves: "Longsleeve", Softshelljacken: "Softshelljacke" }[p.ty] || p.ty.replace(/s$/, ""));
  /* geschützter Bindestrich, damit "T-Shirt" nie am Zeilenende bricht */
  RV.nb = (s) => String(s).replace(/(\S)-(\S)/g, "$1\u2011$2");
  /* Titel in Motiv + Artikel trennen: "Cheers Oversized T-Shirt" -> ["Cheers","Oversized T-Shirt"] */
  RV.splitTitle = (p) => {
    const m = p.t.match(/^(.*?)\s+(Oversized T-Shirt|Oversized Shirt|T-Shirt|Hoodie|Zip-Hoodie|Sweatshirt|Longsleeve|Bomberjacke|Fleecejacke|Open-Hem-Jogger|Jogger|Dad Cap)$/i);
    if (m && /^(RØ|REVØRA)( Clean)?$/.test(m[1])) return [p.t, RV.typeLabel(p)]; /* Logo-Basics: voller Name */
    return m ? [m[1], m[2]] : [p.t, RV.typeLabel(p)];
  };

  /* Farbregel: nie zwei gleiche Farben nebeneinander. Liefert [{p, ci}] */
  /* Farbfamilie: Weiß, Off White und Natural Raw sehen auf Steingrau gleich aus */
  RV.fam = (n) => (/^(White|Off White|Natural Raw)$/.test(n) ? "W" : /^(Union Beige|Beige|Desert Sand)$/.test(n) ? "B" : n);
  RV.pickColors = (list, startPrev = null) => {
    const out = [];
    let prev = startPrev ? RV.fam(startPrev) : null;
    const queue = list.slice();
    while (queue.length) {
      let k = queue.findIndex((p) => p.c.some((c) => RV.fam(c.n) !== prev));
      if (k < 0) k = 0;
      const p = queue.splice(k, 1)[0];
      let ci = p.c.findIndex((c) => RV.fam(c.n) !== prev);
      if (ci < 0) ci = 0;
      out.push({ p, ci });
      prev = RV.fam(p.c[ci].n);
    }
    return out;
  };
  /* Für Raster mit Spalten: zusätzlich nicht gleiche Farbe direkt darüber vermeiden (wenn möglich) */
  /* Raster: vermeidet gleiche Farbfamilie links, darüber – auch für 2- und 3-spaltige Mobil/Tablet-Umbrüche */
  RV.pickColorsGrid = (list, cols = 4) => {
    const out = [];
    const f = (j) => (j >= 0 && out[j] ? RV.fam(out[j].p.c[out[j].ci].n) : null);
    list.forEach((p, i) => {
      const tiers = [[i - 1, i - 2, i - 3, i - cols], [i - 1, i - 2, i - cols], [i - 1, i - cols], [i - 1]];
      let ci = -1;
      for (const t of tiers) { const bad = t.map(f); ci = p.c.findIndex((c) => !bad.includes(RV.fam(c.n))); if (ci >= 0) break; }
      out.push({ p, ci: ci < 0 ? 0 : ci });
    });
    return out;
  };


  /* ---------- Links (echte Shop-URLs, Sprachpräfix aus routes.root_url) ---------- */
  RV.href = {
    home: () => RVM.root,
    c: (h) => RVM.root + "collections/" + h,
    p: (h, color) => RVM.root + "products/" + h + (color ? "?f=" + encodeURIComponent(color) : ""),
    seite: (h) => RVM.root + "pages/" + h,
    maison: () => RVM.root + "pages/uber-uns",
    merkliste: () => RVM.root + "collections/all?view=merkliste",
    suche: (q) => RVM.root + "search?type=product&options%5Bprefix%5D=last&q=" + encodeURIComponent(q || ""),
  };
  RV.link = (u) => {
    if (!u) return RVM.root;
    if (/^(https?:|mailto:|tel:|#)/.test(u)) return u;
    return RVM.root + u.replace(/^\/(en\/)?/, "");
  };
  RV.isExternal = (h) => /^https?:/.test(h) && !h.startsWith(location.origin);

  /* ---------- Icons ---------- */
  const I = {
    menu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M3 7h18M3 12h18M3 17h12"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M5 8h14l-1 13H6L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>',
    heart: '<svg viewBox="0 0 24 24" stroke-linejoin="round"><path d="M12 20.5s-7.5-4.6-7.5-10.3A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 7.5 2.6c0 5.7-7.5 10.3-7.5 10.3Z"/></svg>',
    heartLine: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"><path d="M12 20.5s-7.5-4.6-7.5-10.3A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 7.5 2.6c0 5.7-7.5 10.3-7.5 10.3Z"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="12" cy="8.5" r="3.8"/><path d="M4.5 20.5c1.2-3.6 4-5.3 7.5-5.3s6.3 1.7 7.5 5.3"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="m5 5 14 14M19 5 5 19"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M12 4v16M4 12h16"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M4 12h16"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M4 12h16M14 6l6 6-6 6"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="m9 5 7 7-7 7"/></svg>',
  };
  RV.icon = (n) => I[n] || "";

  /* ---------- Signatur: RØ-Monogramm, Kachel, Wappen ---------- */
  /* RØ = Brust-Druckdatei RO_STICK (Atila 23.10.2026: „so überall“); 2. Parameter (Strich) wirkt nicht mehr */
  const RO_D = "M17.2 11.0L17.2 91.0L24.4 91.0L24.4 60.0L27.3 63.0L31.0 65.8L35.0 67.9L39.2 69.3L43.6 70.1L48.2 70.3L52.5 69.8L56.6 68.6L74.7 91.0L82.8 91.0L82.7 89.4L63.3 65.3L66.0 63.2L68.4 60.9L70.1 59.0L71.8 56.6L73.0 54.5L74.5 51.1L75.5 48.2L76.1 45.1L76.4 42.0L76.4 38.9L76.1 35.8L75.3 32.6L74.3 29.5L73.0 26.8L71.8 24.7L69.8 21.9L68.4 20.4L66.2 18.2L64.3 16.7L62.3 15.4L59.4 13.8L57.5 13.0L55.2 12.2L52.8 11.6L49.3 11.1L46.0 11.0L42.2 11.3L38.7 12.1L35.2 13.4L31.8 15.1L28.9 17.0L26.1 19.4L24.4 17.3L24.4 11.0ZM26.2 31.0L51.9 62.8L48.7 63.3L45.6 63.4L42.7 63.0L39.2 62.1L36.6 61.0L33.6 59.2L31.4 57.4L29.1 54.9L27.5 52.6L26.0 49.9L25.1 47.4L24.4 44.4L24.4 36.9L25.1 33.9ZM34.9 21.2L36.7 20.3L39.0 19.3L40.9 18.7L43.2 18.2L45.2 18.0L47.4 17.9L49.8 18.1L52.1 18.5L54.2 19.1L56.2 19.9L58.1 20.9L60.0 22.1L61.8 23.6L63.4 25.1L64.9 26.9L66.2 28.7L67.3 30.8L68.1 32.8L68.8 34.8L69.3 37.2L69.5 39.5L69.5 41.8L69.0 45.8L68.2 48.2L67.5 50.1L66.5 52.1L65.4 53.8L64.0 55.5L62.3 57.3L60.6 58.7L59.0 59.8L58.8 59.8L30.5 24.8L32.3 23.1Z";
  RV.monoSVG = (farbe = "currentColor") =>
    `<svg viewBox="0 0 100 100"><path fill="${farbe}" fill-rule="evenodd" d="${RO_D}"/></svg>`;
  const tile = (col) => {
    const m = (x, y, s) => `<g transform="translate(${x} ${y}) scale(${s / 100})"><path d="${RO_D}"/></g>`;
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="132" height="132" viewBox="0 0 132 132"><g fill="${col}" fill-rule="evenodd">${m(14, 14, 40)}${m(80, 80, 40)}</g><g fill="${col}"><circle cx="99" cy="33" r="1.6"/><circle cx="33" cy="99" r="1.6"/></g></svg>`;
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
  };
  document.documentElement.style.setProperty("--rv-mono-tile", tile("#ffffff"));
  document.documentElement.style.setProperty("--rv-mono-tile-ink", tile("#0a0a0a"));
  RV.crest = (text = "MAISON REVØRA · HILDESHEIM · MMXXVI · ") => {
    const id = "c" + Math.random().toString(36).slice(2, 7);
    return `<span class="rv-crest" aria-hidden="true"><svg viewBox="0 0 200 200"><defs><path id="${id}" d="M100,100 m-74,0 a74,74 0 1,1 148,0 a74,74 0 1,1 -148,0"/></defs>
      <circle cx="100" cy="100" r="97" fill="none" stroke="currentColor" stroke-width="1"/><circle cx="100" cy="100" r="58" fill="none" stroke="currentColor" stroke-width="1"/>
      <text font-family="RV Jost, sans-serif" font-size="13.2" letter-spacing="4.2" fill="currentColor" font-weight="500"><textPath href="#${id}">${RV.esc(text)}</textPath></text>
      <g transform="translate(68 66) scale(.64)" fill="currentColor" fill-rule="evenodd"><path d="${RO_D}"/></g></svg></span>`;
  };

  /* ---------- Speicher ---------- */
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };
  RV.store = store;

  /* ---------- Toast ---------- */
  let toastT;
  RV.toast = (msg) => {
    const t = $("#rv-toast");
    t.textContent = msg;
    t.classList.add("is-on");
    clearTimeout(toastT);
    toastT = setTimeout(() => t.classList.remove("is-on"), 2400);
  };

  /* ---------- Overlays (Panels, Scrim) ---------- */
  let openPanel = null;
  RV.openPanel = (id) => {
    RV.closeAll();
    const el = $("#" + id);
    if (!el) return;
    el.classList.add("is-on");
    $("#rv-scrim").classList.add("is-on");
    document.body.classList.add("rv-lock");
    openPanel = el;
    setTimeout(() => { const f = el.querySelector("[data-autofocus]"); f && f.focus(); }, 300);
  };
  RV.closeAll = () => {
    $$(".rv-panel.is-on,.rv-search.is-on").forEach((e) => e.classList.remove("is-on"));
    $("#rv-scrim").classList.remove("is-on");
    document.body.classList.remove("rv-lock");
    openPanel = null;
  };

  /* ---------- Merkliste ---------- */
  RV.wish = {
    list: () => store.get("rv_wish", []),
    has: (h) => RV.wish.list().includes(h),
    toggle(h) {
      const l = RV.wish.list();
      const i = l.indexOf(h);
      if (i >= 0) l.splice(i, 1); else l.unshift(h);
      store.set("rv_wish", l);
      RV.wish.sync();
      RV.toast(i >= 0 ? (RVM.en ? "Removed from wishlist" : "Von der Merkliste entfernt") : (RVM.en ? "Saved to wishlist" : "Auf der Merkliste"));
      return i < 0;
    },
    sync() {
      const n = RV.wish.list().length;
      $$("[data-wish-count]").forEach((e) => { e.textContent = n; e.classList.toggle("is-on", n > 0); });
      $$(".rv-heart[data-h]").forEach((b) => b.setAttribute("aria-pressed", RV.wish.has(b.dataset.h) ? "true" : "false"));
    },
  };

  /* ---------- Warenkorb (Shopify-Ajax-API) ---------- */
  const J = { "Content-Type": "application/json", Accept: "application/json" };
  RV.cart = {
    state: { items: [], item_count: CFG.cartCount || 0, total_price: 0, total_discount: 0 },
    loaded: false,
    async refresh() {
      try { const r = await fetch(RVM.root + "cart.js", { headers: { Accept: "application/json" }, cache: "no-store" }); this.state = await r.json(); this.loaded = true; } catch (e) {}
      this.render();
      return this.state;
    },
    async add(p, ci, si, q = 1) {
      const v = RV.variant(p, ci, si);
      if (!v || !v[5]) { RV.toast(RVM.en ? "This size is currently unavailable" : "Diese Größe ist gerade nicht verfügbar"); return false; }
      try {
        const r = await fetch(RVM.root + "cart/add.js", { method: "POST", headers: J, body: JSON.stringify({ items: [{ id: v[0], quantity: q }] }) });
        if (!r.ok) { const e = await r.json().catch(() => ({})); RV.toast(e.description || e.message || (RVM.en ? "Could not add to bag" : "Konnte nicht hinzugefügt werden")); return false; }
      } catch (e) { RV.toast(RVM.en ? "No connection – please try again" : "Keine Verbindung – bitte nochmal versuchen"); return false; }
      await this.refresh();
      this.open();
      document.dispatchEvent(new CustomEvent("rv:cart-add", { detail: { id: v[0], h: p.h, q } }));
      return true;
    },
    async setQty(key, q) {
      try { await fetch(RVM.root + "cart/change.js", { method: "POST", headers: J, body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) }); } catch (e) {}
      return this.refresh();
    },
    items() { return this.state.items || []; },
    count() { return this.state.item_count || 0; },
    total() { return this.state.total_price || 0; },
    checkoutUrl: () => "/checkout",
    open() { this.render(); RV.openPanel("rv-cart"); if (!this.loaded) this.refresh(); },
    render() {
      const n = this.count();
      $$("[data-cart-count]").forEach((e) => { e.textContent = n; e.classList.toggle("is-on", n > 0); });
      const box = $("#rv-cart-body"), ft = $("#rv-cart-ft"), hd = $("#rv-cart-n");
      if (!box) return;
      hd.textContent = n ? `(${n})` : "";
      const l = this.items();
      if (!l.length) {
        box.innerHTML = `<div class="rv-cart__empty"><div style="width:56px;margin:0 auto 22px;color:var(--navy)">${RV.monoSVG()}</div>
          <p class="rv-h3">${RVM.en ? "Your bag is empty" : "Dein Warenkorb ist leer"}</p><p class="rv-small" style="margin:10px 0 26px">${RVM.en ? "Discover this season's new pieces." : "Entdecke die neuen Teile der Saison."}</p>
          <a class="rv-btn" href="${RV.href.c("neu-eingetroffen")}">${RVM.en ? "Discover new" : "Neu entdecken"}</a></div>`;
        ft.hidden = true;
        return;
      }
      ft.hidden = false;
      box.innerHTML = `<div class="rv-cart__list">${l.map((x) => {
        const img = x.image ? RV.imgTag(abs(x.image), { w: 300, sizes: "96px", alt: x.product_title, ws: [200, 300] }) : "";
        const opts = (x.options_with_values || []).filter((o) => o.value !== "Default Title").map((o) => RV.esc(o.value)).join(" · ");
        const disc = (x.line_level_discount_allocations || []).reduce((a, d) => a + d.amount, 0);
        return `<div class="rv-ci"><a class="rv-ph" href="${RV.esc(x.url)}">${img}</a>
          <div><a class="rv-ci__t" href="${RV.esc(x.url)}">${RV.esc(x.product_title)}</a>
          <div class="rv-ci__m">${opts}</div>
          <div class="rv-ci__row"><div class="rv-qty"><button type="button" aria-label="${RVM.en ? "Less" : "Weniger"}" data-q="${RV.esc(x.key)}" data-d="-1">${I.minus}</button><span>${x.quantity}</span><button type="button" aria-label="${RVM.en ? "More" : "Mehr"}" data-q="${RV.esc(x.key)}" data-d="1">${I.plus}</button></div>
          <span>${disc ? `<s class="rv-muted" style="margin-right:6px">${RV.price(x.original_line_price)}</s>` : ""}${RV.price(x.final_line_price)}</span></div>
          <div style="margin-top:6px"><button type="button" class="rv-ci__rm" data-rm="${RV.esc(x.key)}">${RVM.en ? "Remove" : "Entfernen"}</button></div></div></div>`;
      }).join("")}</div>`;
      const td = this.state.total_discount || 0;
      $("#rv-cart-total").textContent = RV.price(this.total());
      $("#rv-cart-disc").innerHTML = td ? `${RVM.en ? "Discount applied" : "Rabatt verrechnet"}: −${RV.price(td)}` : (n < 2 ? RV.esc(D.fakten.staffel) : "");
    },
  };

  /* ---------- Produktkarte ---------- */
  RV.card = (p, ci = 0, o = {}) => {
    const c = p.c[ci] || p.c[0];
    const a = c.im[c.card] || c.im[0], b = c.im[c.hover] || a;
    const href = RV.href.p(p.h, c.n);
    const sizes = o.sizes || "(max-width:760px) 50vw, (max-width:1100px) 33vw, 25vw";
    const [motif, art] = RV.splitTitle(p);
    const sw = p.c.slice(0, 6).map((x, i) => `<button type="button" class="${i === ci ? "is-on" : ""}" style="--c:${x.x}" data-ci="${i}" aria-label="${RV.esc(x.n)}" title="${RV.esc(x.n)}"></button>`).join("");
    const badge = o.badge !== false && p.neu ? `<span class="rv-card__badge">Neu</span>` : "";
    const price = p.cp ? `<s>${RV.price(p.cp)}</s>${RV.price(p.p)}` : ((p.v || []).some((v) => v[3] !== p.p) ? (RVM.en ? "from " : "ab ") : "") + RV.price(p.p);
    return `<article class="rv-card" data-h="${p.h}" data-ci="${ci}"${o.reveal ? ` data-reveal style="--d:${o.delay || 0}s"` : ""}>
      <a class="rv-card__media" href="${href}" aria-label="${RV.esc(p.t)}">${badge}
        ${RV.imgTag(a.u, { w: 700, sizes, alt: a.a, cls: "rv-card__main", eager: !!o.eager })}
        ${RV.imgTag(b.u, { w: 700, sizes, alt: "", cls: "rv-card__alt" })}</a>
      <button class="rv-heart" type="button" data-h="${p.h}" aria-label="Merken" aria-pressed="${RV.wish.has(p.h)}">${I.heart}</button>
      <div class="rv-card__info"><a class="rv-card__t" href="${href}" title="${RV.esc(p.t)}">${RV.esc(motif)}</a>
        <div class="rv-card__a">${RV.esc(RV.nb(art))}</div>
        <div class="rv-card__p">${price}</div>
        ${o.swatches === false || p.c.length < 2 ? "" : `<div class="rv-sw">${sw}${p.c.length > 6 ? `<span class="rv-sw__more">+${p.c.length - 6}</span>` : ""}</div>`}</div>
    </article>`;
  };
  /* Raster mit Farbregel */
  RV.grid = (products, o = {}) => {
    const picks = o.cols ? RV.pickColorsGrid(products, o.cols) : RV.pickColors(products);
    return picks.map(({ p, ci }, i) => RV.card(p, ci, { ...o, delay: o.reveal ? Math.min(i % (o.cols || 4), 4) * 0.08 : 0, eager: o.eagerFirst && i < (o.eagerFirst || 0) })).join("");
  };

  /* Delegierte Klicks für Karten (Farbtupfer + Herz) — global einmal */
  document.addEventListener("click", (e) => {
    const sw = e.target.closest(".rv-card .rv-sw button");
    if (sw) {
      e.preventDefault();
      const card = sw.closest(".rv-card"), p = RV.prod(card.dataset.h), ci = +sw.dataset.ci, c = p.c[ci];
      const a = c.im[c.card] || c.im[0], b = c.im[c.hover] || a;
      const m = card.querySelector(".rv-card__main"), alt = card.querySelector(".rv-card__alt");
      m.srcset = RV.srcset(a.u); m.src = RV.img(a.u, 700); m.alt = a.a;
      alt.srcset = RV.srcset(b.u); alt.src = RV.img(b.u, 700);
      card.querySelectorAll(".rv-sw button").forEach((x) => x.classList.toggle("is-on", x === sw));
      card.dataset.ci = ci;
      const href = RV.href.p(p.h, c.n);
      card.querySelectorAll("a.rv-card__media, a.rv-card__t").forEach((x) => (x.href = href));
      return;
    }
    const hb = e.target.closest(".rv-heart[data-h]");
    if (hb) {
      e.preventDefault();
      const on = RV.wish.toggle(hb.dataset.h);
      hb.classList.remove("pop"); void hb.offsetWidth; if (on) hb.classList.add("pop");
      return;
    }
    if (e.target.closest("[data-close]")) RV.closeAll();
    const op = e.target.closest("[data-open]");
    if (op && !(e.metaKey || e.ctrlKey)) { e.preventDefault(); const t = op.dataset.open; t === "search" ? RV.search.open() : t === "cart" ? RV.cart.open() : RV.openPanel(t); }
    const q = e.target.closest("[data-q]");
    if (q) { const it = RV.cart.items().find((x) => x.key === q.dataset.q); if (it) RV.cart.setQty(it.key, it.quantity + +q.dataset.d); }
    const rm = e.target.closest("[data-rm]");
    if (rm) RV.cart.setQty(rm.dataset.rm, 0);
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { RV.closeAll(); RV.closeMega && RV.closeMega(); } });

  /* ---------- Reveal ---------- */
  const io = "IntersectionObserver" in window ? new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); } }), { rootMargin: "0px 0px -8% 0px", threshold: 0.06 }) : null;
  RV.reveal = (root = document) => $$("[data-reveal]:not(.is-in)", root).forEach((el) => (io ? io.observe(el) : el.classList.add("is-in")));
  if (navigator.webdriver || /[?&]static/.test(location.search)) document.documentElement.classList.add("rv-static");

  /* ---------- Navigation fürs Seiten-Menü (gleiche Punkte wie die Leiste) ---------- */
  const T = (de, en) => (RVM.en ? en : de);
  const NAV = [
    { t: T("Neu", "New"), u: "collections/neu-eingetroffen" },
    { t: "Shirts", u: "collections/t-shirts", sub: [[T("Alle Shirts", "All shirts"), "collections/t-shirts"], ["Azur Club", "collections/azur-club"], ["Riviera", "collections/riviera"], [T("Für Sie", "For her"), "collections/fuer-sie"], [T("Für Ihn", "For him"), "collections/fuer-ihn"]] },
    { t: T("Hoodies & Pullover", "Hoodies & Sweaters"), u: "collections/hoodies", sub: [["Hoodies", "collections/hoodies"], ["Zip-Hoodies", "collections/zip-hoodies"], ["Sweatshirts", "collections/sweatshirts"], ["Longsleeves", "collections/longsleeves"]] },
    { t: T("Jacken", "Jackets"), u: "collections/jacken", sub: [[T("Jacken", "Jackets"), "collections/jacken"], ["Jogger", "collections/jogger"], [T("Accessoires", "Accessories"), "collections/accessoires"]] },
    { t: "Winter", u: "collections/winter", it: true },
    { t: "Azur Club", u: "collections/azur-club", it: true },
    { t: "Riviera", u: "collections/riviera", it: true },
    { t: T("Alle Teile", "All pieces"), u: "collections/all", sub: [[T("Alle Teile", "All pieces"), "collections/all"], [T("Geschenke unter 50 €", "Gifts under €50"), "collections/geschenke-unter-50"], [T("Merkliste", "Wishlist"), "collections/all?view=merkliste"]] },
    { t: "Maison", u: "pages/uber-uns" },
  ];
  RV.NAV = NAV;

  /* Mega-Menü-Daten nachladen (nicht blockierend) */
  let megaP = null;
  RV.loadMega = () => megaP || (megaP = fetch(RVM.pv(RVM.root + "collections/all?view=rvm-mega"), { credentials: "same-origin" })
    .then((r) => r.text()).then((t) => { const j = JSON.parse(t); if (!j || !j.tiles) throw new Error("mega"); RV.addProducts(j.products); RV.megaTiles = j.tiles; fillMega(); return j; })
    .catch(() => null));
  function tileHTML({ p, ci }) {
    const c = p.c[ci], im = c.im[c.card] || c.im[0];
    return `<a class="rv-mega__tile" href="${RV.href.p(p.h, c.n)}"><div class="rv-ph">${RV.imgTag(im.u, { w: 400, sizes: "18vw", alt: im.a, ws: [300, 400, 600] })}</div><span>${RV.esc(RV.splitTitle(p)[0])}</span><small>${RV.price(p.p)}</small></a>`;
  }
  function fillMega() {
    const tl = RV.megaTiles || {};
    $$("[data-mega-tiles]").forEach((box) => {
      if (box.dataset.done) return;
      const ps = (tl[box.dataset.megaTiles] || []).map(RV.prod).filter(Boolean);
      if (!ps.length) return;
      box.innerHTML = RV.pickColors(ps).slice(0, 4).map(tileHTML).join("");
      box.dataset.done = "1";
    });
    const feat = $("#rv-menu-feat");
    if (feat && !feat.dataset.done) {
      const ps = [(tl.winter || [])[0], (tl.azur || [])[0]].map(RV.prod).filter(Boolean);
      feat.innerHTML = RV.pickColors(ps).map(({ p, ci }) => { const c = p.c[ci], im = c.im[c.card]; return `<a href="${RV.href.p(p.h, c.n)}"><div class="rv-ph">${RV.imgTag(im.u, { w: 400, sizes: "220px", alt: im.a, ws: [300, 400] })}</div><span>${RV.esc(RV.splitTitle(p)[0])}</span></a>`; }).join("");
      feat.dataset.done = "1";
    }
  }

  function buildPanels() {
    const menuHTML = NAV.map((n) => n.sub
      ? `<div class="rv-menu__it"><button type="button" class="rv-menu__a" data-acc>${RV.esc(n.t)}${I.plus}</button><div class="rv-menu__sub"><div>${n.sub.map(([t, u]) => `<a href="${RV.link(u)}">${RV.esc(t)}</a>`).join("")}</div></div></div>`
      : `<div class="rv-menu__it"><a class="rv-menu__a" href="${RV.link(n.u)}">${n.it ? `<span class="rv-it">${RV.esc(n.t)}</span>` : RV.esc(n.t)}${I.chev}</a></div>`).join("");
    const logo = D.logo ? `<img src="${RV.img(D.logo, 400)}" alt="REVØRA" style="height:24px;width:auto">` : "REVØRA";
    document.body.insertAdjacentHTML("beforeend", `
      <div class="rv-scrim" id="rv-scrim" data-close></div>
      <aside class="rv-panel rv-panel--l" id="rv-menu" aria-label="${T("Menü", "Menu")}">
        <div class="rv-panel__hd">${logo}<button type="button" class="rv-x" data-close aria-label="${T("Schließen", "Close")}">${I.close}</button></div>
        <div class="rv-panel__bd"><div class="rv-menu">${menuHTML}
          <div class="rv-menu__feat" id="rv-menu-feat"></div>
          <div class="rv-menu__meta"><a href="${RV.link("pages/faq")}">FAQ</a><a href="${RV.link("pages/versand-lieferung")}">${T("Versand &amp; Lieferung", "Shipping &amp; delivery")}</a><a href="${RV.link("pages/ruckgabe-umtausch")}">${T("Rückgabe &amp; Umtausch", "Returns &amp; exchanges")}</a><a href="${RV.link("pages/contact")}">${T("Kontakt", "Contact")}</a><a href="${RV.link("account")}">${T("Mein Konto", "My account")}</a></div>
        </div></div>
      </aside>
      <aside class="rv-panel rv-panel--r" id="rv-cart" aria-label="${T("Warenkorb", "Bag")}">
        <div class="rv-panel__hd"><span class="rv-label">${T("Warenkorb", "Bag")} <span id="rv-cart-n"></span></span><button type="button" class="rv-x" data-close aria-label="${T("Schließen", "Close")}">${I.close}</button></div>
        <div class="rv-panel__bd" id="rv-cart-body"></div>
        <div class="rv-panel__ft" id="rv-cart-ft" hidden>
          <div class="rv-cart__sum"><span class="rv-label">${T("Zwischensumme", "Subtotal")}</span><b id="rv-cart-total"></b></div>
          <p class="rv-cart__note">${T("inkl. MwSt. · Standardversand nach DE · CH kostenlos", "incl. VAT · free standard shipping to DE · CH")}<br><span id="rv-cart-disc"></span></p>
          <a class="rv-btn rv-btn--block" id="rv-checkout" href="/checkout">${T("Zur Kasse", "Checkout")}</a>
          <div class="rv-perks"><span>${T("14 Tage Widerruf", "14-day withdrawal")}</span><span>${T("DHL mit Tracking", "DHL with tracking")}</span><span>${T("Sicher bezahlen", "Secure payment")}</span></div>
        </div>
      </aside>
      <div class="rv-search" id="rv-search" role="dialog" aria-label="${T("Suche", "Search")}">
        <div class="rv-search__hd">${logo.replace('style="', 'style="margin-right:auto;')}<button type="button" class="rv-x" data-close aria-label="${T("Schließen", "Close")}">${I.close}</button></div>
        <div class="rv-search__in"><label class="rv-search__f">${I.search}<input id="rv-q" type="search" placeholder="${T("Wonach suchst du?", "What are you looking for?")}" autocomplete="off" data-autofocus></label>
          <div class="rv-search__chips">${["Hoodie", "Winter", "Riviera", "Navy", "Zip-Hoodie", "Longsleeve", T("Jacke", "Jacket"), "Cap"].map((t) => `<button type="button" class="rv-chip" data-sq="${t}">${t}</button>`).join("")}</div></div>
        <div class="rv-search__res"><div class="rv-wrap" id="rv-search-res"></div></div>
      </div>
      <div class="rv-toast" id="rv-toast" role="status"></div>`);
    $$("#rv-menu [data-acc]").forEach((b) => b.addEventListener("click", () => b.parentElement.classList.toggle("is-open")));
  }

  function bindHeader() {
    /* Ankündigung rotieren */
    const ai = $$(".rv-ann__i"); let k = 0;
    if (ai.length > 1 && !document.documentElement.classList.contains("rv-static")) setInterval(() => { ai[k].classList.remove("is-on"); k = (k + 1) % ai.length; ai[k].classList.add("is-on"); }, 4200);
    /* Mega-Menü: Hover/Fokus mit Verzögerung, Esc */
    const setOpen = (li, on) => { li.classList.toggle("is-open", on); const a = li.querySelector(".rv-nav__a[aria-haspopup]"); if (a) a.setAttribute("aria-expanded", on ? "true" : "false"); };
    RV.closeMega = () => $$(".rv-nav__li.is-open").forEach((x) => setOpen(x, false));
    $$(".rv-nav__li").forEach((li) => {
      let t;
      if (!li.querySelector(".rv-mega")) return;
      const open = () => { RV.loadMega(); $$(".rv-nav__li.is-open").forEach((x) => x !== li && setOpen(x, false)); setOpen(li, true); };
      li.addEventListener("mouseenter", () => { clearTimeout(t); t = setTimeout(open, 90); });
      li.addEventListener("mouseleave", () => { clearTimeout(t); t = setTimeout(() => setOpen(li, false), 140); });
      li.addEventListener("focusin", () => { clearTimeout(t); open(); });
      li.addEventListener("focusout", (e) => { if (!li.contains(e.relatedTarget)) setOpen(li, false); });
    });
    /* Header beim Scrollen */
    const hdr = $("#rv-hdr");
    if (!hdr) return;
    /* Tempo 19.10.2026: höchstens einmal pro Bild (rAF), Höhe der Ankündigungsleiste gemerkt statt bei
       jedem Scroll-Ereignis gemessen, und nur geschrieben, was sich wirklich ändert. */
    let lastY = 0, raf = 0, annCache = -1, lastTop = "";
    const annH = () => { if (annCache < 0) annCache = ($(".rv-ann") || {}).offsetHeight || 0; return annCache; };
    window.addEventListener("resize", () => { annCache = -1; }, { passive: true });
    const setCls = (c, on) => { if (hdr.classList.contains(c) !== on) hdr.classList.toggle(c, on); };
    const onScroll = () => {
      raf = 0;
      const y = window.scrollY;
      const over = hdr.classList.contains("is-over");
      const top = Math.max(0, annH() - y) + "px";
      if (top !== lastTop) { hdr.style.setProperty("--hdr-top", top); lastTop = top; }
      setCls("is-solid", over ? y > window.innerHeight * 0.55 : y > 4);
      const goingDown = y > lastY && y > 420;
      setCls("is-hidden", goingDown && !$(".rv-nav__li.is-open") && !document.body.classList.contains("rv-lock"));
      lastY = y;
    };
    window.addEventListener("scroll", () => { if (!raf) raf = requestAnimationFrame(onScroll); }, { passive: true });
    RV._onScroll = onScroll;
    onScroll();
    $$("[data-rv-crest]").forEach((c) => (c.outerHTML = RV.crest()));
  }

  /* ---------- Suche (Overlay) ---------- */
  const normq = (s) => s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/ø/g, "o");
  RV.searchProducts = (q) => {
    const words = normq(q).split(/\s+/).filter(Boolean);
    if (!words.length) return [];
    return D.products.filter((p) => { const s = normq([p.t, p.ty, p.tags.join(" "), p.c.map((c) => c.n).join(" "), p.col.join(" ")].join(" ")); return words.every((w) => s.includes(w)); });
  };
  let sqT = 0;
  RV.search = {
    open() { RV.closeAll(); $("#rv-search").classList.add("is-on"); document.body.classList.add("rv-lock"); setTimeout(() => $("#rv-q").focus(), 250); RV.search.run($("#rv-q").value); },
    async run(q) {
      const res = $("#rv-search-res"), my = ++sqT;
      $$(".rv-chip[data-sq]").forEach((c) => c.classList.toggle("is-on", normq(c.dataset.sq) === normq(q.trim())));
      if (!q.trim()) {
        await RV.loadMega();
        if (my !== sqT) return;
        const list = ((RV.megaTiles || {}).neu || []).map(RV.prod).filter(Boolean).slice(0, 8);
        res.innerHTML = `<div class="rv-search__cnt rv-eyebrow rv-muted">${T("Neu eingetroffen", "New arrivals")}</div><div class="rv-grid">${RV.grid(list, { sizes: "(max-width:760px) 50vw, 25vw", cols: 4 })}</div>`;
        RV.wish.sync();
        return;
      }
      let items = [];
      try {
        const r = await fetch(RVM.root + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last", { headers: { Accept: "application/json" } });
        const j = await r.json();
        items = ((j.resources || {}).results || {}).products || [];
      } catch (e) {}
      if (my !== sqT) return;
      await RV.fetchProducts(items.map((x) => x.handle));
      if (my !== sqT) return;
      const list = items.map((x) => RV.prod(x.handle)).filter(Boolean);
      res.innerHTML = `<div class="rv-search__cnt rv-eyebrow rv-muted">${list.length ? T(`Ergebnisse für „${RV.esc(q)}“`, `Results for “${RV.esc(q)}”`) : ""}</div>
        ${list.length ? `<div class="rv-grid">${RV.grid(list, { sizes: "(max-width:760px) 50vw, 25vw", cols: 4 })}</div>` : `<p class="rv-h3" style="margin-top:20px">${T("Nichts gefunden – versuch „Hoodie“ oder „Riviera“.", "Nothing found – try “Hoodie” or “Riviera”.")}</p>`}
        <div class="rv-center" style="margin-top:40px"><a class="rv-btn rv-btn--ghost" href="${RV.href.suche(q)}">${T("Alle Ergebnisse ansehen", "View all results")}</a></div>`;
      RV.wish.sync();
    },
  };
  document.addEventListener("input", RV.debounce((e) => { if (e.target.id === "rv-q") RV.search.run(e.target.value); }, 220));
  document.addEventListener("click", (e) => { const c = e.target.closest("[data-sq]"); if (c) { $("#rv-q").value = c.dataset.sq; RV.search.run(c.dataset.sq); } });
  document.addEventListener("keydown", (e) => { if (e.target.id === "rv-q" && e.key === "Enter" && e.target.value.trim()) location.href = RV.href.suche(e.target.value.trim()); });

  /* ---------- Seitenstart ---------- */
  RV.page = (name, def) => (RV.pages[name] = def);
  function readData(root = document) {
    $$('script[type="application/json"][data-rv-products]', root).forEach((s) => { try { RV.addProducts(JSON.parse(s.textContent)); } catch (e) { console.error("rv-products", e); } });
    $$('script[type="application/json"][data-rv-collections]', root).forEach((s) => { try { RV.addCollections(JSON.parse(s.textContent)); } catch (e) { console.error("rv-collections", e); } });
  }
  RV.readData = readData;
  function boot() {
    buildPanels();
    bindHeader();
    readData();
    const main = $("#rv-main");
    if (main && main.dataset.rvPage) {
      const def = RV.pages[main.dataset.rvPage];
      let params = {};
      try { params = JSON.parse(main.dataset.rvParams || "{}"); } catch (e) {}
      const ctx = { name: main.dataset.rvPage, params, query: Object.fromEntries(new URLSearchParams(location.search)) };
      if (def) {
        const over = (typeof def.header === "function" ? def.header(ctx) : def.header) === "over";
        $("#rv-hdr") && $("#rv-hdr").classList.toggle("is-over", over);
        document.body.classList.toggle("rv-has-over", over);
        try { def.render(main, ctx); main.classList.add("is-rendered"); } catch (err) { console.error(err); main.classList.add("is-failed"); }
      }
    }
    RV.reveal(document);
    RV.wish.sync();
    RV.cart.render();
    RV._onScroll && RV._onScroll();
    const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
    idle(() => { RV.loadMega(); if (!RV.cart.loaded) RV.cart.refresh(); });
  }
  /* Start erst, wenn alle (defer-)Seitenskripte registriert sind */
  let booted = false;
  const go = () => { if (booted) return; booted = true; boot(); };
  document.addEventListener("DOMContentLoaded", go);
  window.addEventListener("load", go);
  if (document.readyState === "complete") go();
})();
